import axios from 'axios'

const baseDomain = process.env.VUE_APP_API_BASE_URL
const baseURL = `${baseDomain}/private/api/wattanders/v1`

export default axios.create({
  baseURL
})
